import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({ name: 'customCalendarCellBlankImage' })
export class CustomCalendarCellBlankImagePipe implements PipeTransform {
  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns list of rooms filtered by search text or []
   * @param event
   * @param key
   */
  transform(event: any, key = 'dimensionUrl'): string {
    const url = get(event, key, null);
    if (url) {
      return url;
    }
    return 'https://s3.amazonaws.com/production.tsolife.com/2024-10-10/pHHVdgp9rGDVTRVE8NfConGDBKprQHbX71GKxOXU.png';
  }
}
